import transform from 'lodash/transform'
import isObject from 'lodash/isObject'

const changeCase = (str) => {
  return str.toUpperCase() === str
    ? str.toLowerCase()
    : str.charAt(0).toLowerCase() + str.slice(1)
}

/**
 * Recursively change the case of all keys of a object
 * @param {*} object The object ot be transformed
 * @returns {*}
 */
export const pascalToCamelCase = object => transform(object, (result, val, key) => {
  const newKey = changeCase(key)

  if (Array.isArray(val)) {
    const newVal = val.map(item => isObject(item) ? pascalToCamelCase(item) : item)

    result[newKey] = newVal
  } else {
    result[newKey] = isObject(val) ? pascalToCamelCase(val) : val
  }
})

export default pascalToCamelCase